module.exports = __webpack_public_path__ + "static/media/1.0e04f2f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/9026/1.jpg
// module id = 874
// module chunks = 0